<div
  *ngIf="itemsLeftAfterFilter === 0 && listCount > 0"
  data-cy="list-detail-no-products-in-group-section"
  class="no-products-in-group-section"
>
  <span data-cy="list-detail-no-products-in-group-text">
    {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
  </span>
  <span data-cy="list-detail-no-products-in-group-subtext">
    {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
  </span>
</div>

<div
  *ngIf="listCount === 0 || (itemsLeftAfterFilter === 1 && isListManagement)"
  data-cy="list-detail-no-products-in-list"
  class="no-products-in-list-section"
  [class.mobile]="isMobile"
>
  <span data-cy="list-detail-no-products-in-list-text">
    {{ 'i18n.search.noProducts.noProductsFound' | translate }}
  </span>
  <span
    *ngIf="isEditableList && !isListManagement"
    data-cy="list-detail-no-products-in-list-subtext"
  >
    {{ 'i18n.search.noProducts.pleaseAddProducts' | translate }}
  </span>
  <div *ngIf="isEditableList && !isListManagement" class="add-products-section">
    <ion-button
      data-cy="list-management-add-products-button"
      class="usf-fill-green-button"
      (click)="onAddProductAction()"
    >
      {{ 'i18n.common.addProducts' | translate }}
    </ion-button>
  </div>
</div>
